import { useContext, useEffect } from "react";
import { UserContext } from "@/contexts/user-context";
import { isWindow } from "@/service/render-environment";
import { useEnvContext } from "next-runtime-env";

export const FacebookDefaultAdvertising = () => {
  const { isLoggedIn, keyType } = useContext(UserContext);
  const { NEXT_PUBLIC_FACEBOOK_PIXEL_ID } = useEnvContext();

  useEffect(() => {
    if (!isWindow() || !window.fbq) {
      return;
    }

    window?.fbq("init", NEXT_PUBLIC_FACEBOOK_PIXEL_ID);
    window?.fbq("track", "PageView", {
      logged_in: isLoggedIn,
    });

    if (isLoggedIn) {
      window?.fbq("trackCustom", "User", { type: keyType || "empty" });
    }
  });

  return <></>;
};
